import { AdjustmentFilter } from '@pixi/filter-adjustment';
import Component from './Component';
import GameObject from '../GameObject/GameObject';

export default class ColorFilter extends Component {
    public filter: AdjustmentFilter;

    constructor() {
        super();
        this.filter = new AdjustmentFilter();
    }

    protected onAttach(
        gameObject: GameObject,
        container: PIXI.Container
    ): void {
        container.filters = [this.filter];
    }

    protected onDetach(
        gameObject: GameObject,
        container: PIXI.Container
    ): void {
        const index = container.filters.indexOf(this.filter);
        if (index >= 0) container.filters.splice(index, 1);
    }

    get brightness(): number {
        return this.filter.brightness;
    }

    set brightness(value: number) {
        this.filter.brightness = value;
    }

    get saturation(): number {
        return this.filter.saturation;
    }

    set saturation(value: number) {
        this.filter.saturation = value;
    }
}
